import type { LoginBody, RegisterBody, UserView } from "@bibleunleashed/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, ApiError, post } from "./api";

const KEY = ["me"];

export function useUser() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      try {
        return await api<UserView>("/api/auth/me");
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 5 * 60_000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LoginBody) => post<UserView>("/api/auth/login", body),
    onSuccess: (user) => qc.setQueryData(KEY, user),
  });
}

export function useRegister() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: RegisterBody) => post<UserView>("/api/auth/register", body),
    onSuccess: (user) => qc.setQueryData(KEY, user),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => post<null>("/api/auth/logout", {}),
    onSuccess: () => {
      qc.setQueryData(KEY, null);
      void qc.invalidateQueries();
    },
  });
}
